import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { AuthGate } from "./components/shell/AuthGate";
import { LightboxProvider } from "./components/shell/Lightbox";
import "./styles/index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <AuthGate>
      {/* Above App, not inside a surface: its keydown listener has to be registered before any
          surface's, and it must survive the unmount a rail click does to whatever is showing. */}
      <LightboxProvider>
        <App />
      </LightboxProvider>
    </AuthGate>
  </StrictMode>,
);
